// extracted by mini-css-extract-plugin
module.exports = {"page-preview":"page-preview__XlYqB"};